import { formatTimestampToPortalTz, formatTimestampToUTCTzDate } from 'flow-doctor-lib/utils/dateTimeUtils';
export const isEmptyPropertyValue = (evalData, propertyWrapper) => {
  var _evalData$propertyVal;
  const isEmptyDateValue = ((_evalData$propertyVal = evalData.propertyValue) === null || _evalData$propertyVal === void 0 ? void 0 : _evalData$propertyVal.value) === '' && ((propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.property.type) === 'date' || (propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.property.type) === 'datetime');
  return !evalData.propertyValue || isEmptyDateValue;
};
export const formatPropertyValue = (propertyValue, propertyWrapper) => {
  if (!propertyWrapper || !propertyValue) {
    return propertyValue;
  }
  if (propertyWrapper.property.type === 'date') {
    return formatTimestampToUTCTzDate(Number(propertyValue));
  }
  if (propertyWrapper.property.type === 'datetime') {
    return formatTimestampToPortalTz(Number(propertyValue));
  }
  return propertyValue;
};